import React from 'react';
import Image from 'next/image';

import useMediaQuery from 'utils/useMediaQuery';

import { Control } from './Control';
import styles from './ControlHero.module.scss';

interface Props {
  title: string;
  text: string;
  controlTitle: string;
  controlButtonText: string;
  mobileSrc: string;
  desktopSrc: string;
}

export const ControlHero: React.FC<Props> = ({
  title,
  text,
  controlTitle,
  controlButtonText,
  mobileSrc,
  desktopSrc,
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <Image
          layout="fill"
          objectFit="cover"
          src={isMobile ? mobileSrc : desktopSrc}
          alt={title}
        />
        <div className={styles.texts}>
          <h1>{title}</h1>
          <p>{text}</p>
        </div>
        <Control title={controlTitle} buttonText={controlButtonText} />
      </div>
    </div>
  );
};
